/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccommodationId } from './AccommodationId';
import type { CheapestRate } from './CheapestRate';
import type { Distances } from './Distances';
import type { Image } from './Image';
import type { InternalAmenityGroup } from './InternalAmenityGroup';
import type { InternalLabel } from './InternalLabel';
import type { Listing } from './Listing';
export type Accommodation = {
    cheapestRate?: CheapestRate | null;
    guaranteedPosition?: boolean;
    distance?: number | null;
    distances?: Distances | null;
    id?: string;
    name?: string;
    path?: string;
    settlementName?: string;
    longitude?: number | null;
    latitude?: number | null;
    ratingsAverage?: number | null;
    ratingsCount?: number;
    address?: string;
    type?: string;
    source?: string;
    currency?: string;
    streetNumber?: string | null;
    internalLabel?: InternalLabel | null;
    internalAmenityGroups?: Array<InternalAmenityGroup>;
    images?: Array<Image>;
    listing?: Listing | null;
    aboOta?: boolean;
    active?: boolean;
    foreignPartnerId?: number | null;
    ratingDescription?: Accommodation.ratingDescription;
    caption?: string | null;
    distanceFromCenter?: number | null;
    bestseller?: boolean;
    sort?: any[] | null;
    postalCode?: string;
    isNocClone?: boolean;
    settlementId?: number | null;
    isFlagged?: boolean;
    placement?: Accommodation.placement;
    readonly identifier?: AccommodationId;
    readonly nocClone?: boolean;
    readonly flagged?: boolean;
};
export namespace Accommodation {
    export enum ratingDescription {
        AVERAGE = 'average',
        DECENT = 'decent',
        GOOD = 'good',
        VERY_GOOD = 'veryGood',
        SENSATIONAL = 'sensational',
    }
    export enum placement {
        GUARANTEE = 'Guarantee',
        SORT = 'Sort',
        PLACEHOLDER = 'Placeholder',
        NEARBY = 'Nearby',
    }
}
